export const environment = {
  production: true,
  apibase: 'https://backend-groeimeter-p.cito.nl/',
  basispoort_login: 'https://www.basispoort.nl/login/leerkracht/snelkoppelaar?TARGET=',
  demomode: false,
  jwt: 'jwt',
};
